// import GreetingSection from 'components/navbar/GreetingSection';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Row, Col, Divider, Button, Switch, Form, Collapse } from 'antd';
import { useEffect, useState, Fragment } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isLocaleEnglish } from 'utils/languageUtils';
import { useBeneficiaries } from 'contexts/beneficiaries/context';
import { beneficiariesForm } from 'contexts/beneficiaries/beneficiariesForm';
import RedUp from 'assets/images/MakeRequest/red-up.svg';
import RedDown from 'assets/images/MakeRequest/red-down.svg';
import Visibility from 'assets/images/eye-open.svg';
import VisibilityOff from 'assets/images/eye-off.svg';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
const { Panel } = Collapse;
import Added from 'assets/images/MakeRequest/Added.svg';
import Removed from 'assets/images/MakeRequest/Removed.svg';
import { DocumentsCard } from './DocumentsCard'; //給tax用的
import { Attachments } from 'types';
import { formatIdlast5 } from 'utils/formate/cardNumber';
import moment from 'moment';
import { BeneficiariesActionTypes } from 'contexts/beneficiaries/action';

const ViewBeneficiariesContainer = styled.div`
  margin: 0;
`;
interface PdRowProps {
  paddingFlag?: string;
  padB?: string;
}
interface DividerLineProps {
  padB?: string;
}
const StyledBlock = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`;
const Androw = styled(Row)<PdRowProps>`
  max-width: 640px;
  margin: 0 auto;
  // background: #fff;
  padding-top: ${(props) => (props.paddingFlag ? props.paddingFlag : `0`)};
  padding-bottom: ${(props) => (props.padB ? props.padB : `0`)};
`;
const AndCol = styled(Col)`
  margin: 0 20px;
`;
const AntDivider = styled(Divider)`
  border-color: #cccccc;
`;
const FlexCol = styled(Col)<{ flag?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: ${(props) => (props.flag ? '0 16px' : '0')};
`;
export default function BeneficiariesList() {
  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);
  const [policyNumber, setPolicyNumber] = useState('');
  const [primaryData, setPrimaryData] = useState<beneficiariesForm[]>([]);
  const [secondary, setSecondary] = useState<beneficiariesForm[]>([]);
  const { state, policyNC, oldBeneficiariesList, pep, highRiskC, highRiskP, dispatch, setPep } = useBeneficiaries();
  const navigate = useNavigate();
  const location = useLocation();
  const { checkValue } = (location.state as { checkValue?: boolean }) ?? {};
  const allObj: (keyof beneficiariesForm)[] = [
    'surname',
    'givenName',
    'share',
    'relationship',
    'gender',
    'birthDate',
    'idType',
    'idNo',
    'birthCountry',
    'residenceCountry',
    'taxResidence',
    'specifyRelationship',
  ]; //配置所有需要属性
  const descObj: (keyof beneficiariesForm)[] = [
    'relationship',
    'gender',
    'idType',
    'birthCountry',
    'residenceCountry',
    'taxResidence',
  ]; //配置需要单独处理的属性
  const showObj: (keyof beneficiariesForm)[] = [
    'surname',
    'givenName',
    'share',
    'relationship',
    'gender',
    'birthDate',
    'idType',
    'idNo',
    'birthCountry',
    'residenceCountry',
    'taxResidence',
  ]; //配置需要展示的属性
  const [documentInvalid, setDocumentInvalid] = useState<boolean>(false);

  const [showMoreList, setShowMoreList] = useState<{ id: string; show: boolean; showIdcard: boolean }[]>([]);
  const [addno, setAddno] = useState(0);
  const [removeno, setRemoveno] = useState(0);
  const [isShowPep, setIsShowPep] = useState(false);
  const [showBB, setShowBB] = useState(true);
  const [form] = Form.useForm<{ attachments: Attachments }>();

  useEffect(() => {
    const primaryData = state.filter((item) => item.role !== 'G');
    const secondary = state.filter((item) => item.role === 'G');
    setPrimaryData(primaryData ?? []);
    setSecondary(secondary ?? []);
    setAddno(state.filter((item) => item.beneficiaryAction == 'add').length);
    setRemoveno(state.filter((item) => item.beneficiaryAction == 'removed').length);

    setShowMoreList(
      state.map((item) => ({
        id: item.id as string,
        show: item.beneficiaryAction == 'add' || item.beneficiaryAction == 'updated' ? true : false,
        showIdcard: true,
      })),
    );
  }, [state]);

  const DividerLine = ({ padB }: DividerLineProps) => {
    return (
      <Androw justify="start" padB={padB}>
        <AndCol style={{ width: '100%' }}>
          <AntDivider style={{ margin: '12px 0' }}></AntDivider>
        </AndCol>
      </Androw>
    );
  };
  const openMore = (item: beneficiariesForm) => {
    // console.log(item);
    setShowMoreList((prevList) => {
      return prevList.map((more) => (more.id === item.id ? { ...more, show: !more.show } : more));
    });
  };
  const openMask = (item: beneficiariesForm) => {
    // console.log(item);
    setShowMoreList((prevList) => {
      return prevList.map((more) => (more.id === item.id ? { ...more, showIdcard: !more.showIdcard } : more));
    });
  };
  useEffect(() => {
    if (policyNC) setPolicyNumber(policyNC);
  }, [policyNC]);
  const confirmList = async () => {
    const arr = state.map((beneficiary) => {
      beneficiary.share = beneficiary.share.indexOf('%') != -1 ? beneficiary.share : beneficiary.share + '%';
      if (beneficiary.beneficiaryAction == 'updated') {
        const item = oldBeneficiariesList.find((old) => old.id == beneficiary.id) || beneficiary;
        const updatedBeneficiary = { ...beneficiary }; // 浅拷贝
        // 遍历 allObj 中的字段，检查值是否变化，若变化则拼接 (updated)
        allObj.map((key) => {
          if (
            (key == 'taxResidence' &&
              JSON.stringify([...(beneficiary[key] || [])].sort()) != JSON.stringify([...(item[key] || [])].sort())) ||
            (key == 'share' && beneficiary[key] != (item[key].indexOf('%') != -1 ? item[key] : item[key] + '%')) ||
            (key != 'share' && key != 'taxResidence' && beneficiary[key] != item[key])
          ) {
            if (descObj.includes(key)) {
              const descKey = `${key}Desc` as keyof beneficiariesForm;
              (updatedBeneficiary[descKey] as string) = `${beneficiary[descKey]} (Updated)`;
            } else (updatedBeneficiary[key] as string) = `${beneficiary[key]} (Updated)`;
          }
        });
        return updatedBeneficiary;
      } else return beneficiary;
    });
    await dispatch({
      type: BeneficiariesActionTypes.SET,
      payload: [...arr],
    });
    navigate('/LIBenefiaries/LifeBeneficiariesOtpVerificationPage', {
      state: {
        files: form.getFieldValue('attachments'),
      },
    });
  };
  useEffect(() => {
    if (!Array.isArray(state)) return;

    const hasValidAction = state.some(
      (item) => item?.beneficiaryAction === 'updated' || item?.beneficiaryAction === 'add',
    );
    if (!hasValidAction) setPep({ type: 'SAVE_PEP', payload: { ...pep, isDeclaration: '-' } });
    setIsShowPep(hasValidAction);
    // eslint-disable-next-line
  }, [state]);
  useEffect(() => {
    const handleBack = () => {
      console.log('用户点击了浏览器返回按钮');
    };
    window.addEventListener('popstate', handleBack);
    return () => window.removeEventListener('popstate', handleBack);
  }, []);

  const showShare = (value: string) => {
    if (value == '0%') return '-';
    else if (value.indexOf('%') != -1) return value;
    else return value + '%';
  };
  return (
    <ViewBeneficiariesContainer className="view-beneficiaries-new">
      <div>
        <StyledBlock className="account-detail">
          {policyNumber && (
            <>
              <StyledBlock className="back-f" style={{ marginBottom: 0 }}>
                <Androw justify="start" paddingFlag="16px">
                  <AndCol className="font-size26 grey-font">{t('life.beneficiaries.confirmform')}</AndCol>

                  <AndCol className="font-setting700 font-size17" span={22} style={{ color: '#E9573D' }}>
                    {t('life.beneficiaries.submitafter.confirmdesc')}
                  </AndCol>
                </Androw>
                {checkValue && (
                  <>
                    <Androw
                      justify="start"
                      paddingFlag="16px"
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        paddingBottom: 10,
                      }}
                    >
                      <AntDivider style={{ margin: '12px 0 12px 0' }}></AntDivider>
                      <AndCol
                        style={{
                          fontSize: '20px',
                          fontFamily: 'Roboto400',
                          color: '#20252B',
                          marginLeft: 32,
                        }}
                      >
                        <p style={{ marginBottom: 0 }}>{t('life.policies.noBeneficiaries')}</p>
                        <p style={{ marginBottom: 0, fontSize: '17px' }}>{t('life.beneficiaries.own')}</p>
                      </AndCol>
                      <AndCol>
                        <Switch checked={checkValue} disabled />
                      </AndCol>
                    </Androw>
                    <Androw
                      justify="space-between"
                      className="pointer"
                      style={{
                        opacity: 0.4,
                      }}
                    >
                      <AndCol span={22}>
                        <Androw justify="start">
                          <FlexCol>
                            <span className="font-size20" style={{ marginLeft: '12px' }}>
                              {t('life.policies.hasnoBeneficiaries')}
                            </span>
                          </FlexCol>
                        </Androw>
                      </AndCol>

                      <AndCol>
                        <Androw justify="start">
                          <FlexCol>
                            <span className="font-size17 grey-font" style={{ marginLeft: '12px' }}>
                              {t('life.policies.hasBenefitDes')}
                            </span>
                          </FlexCol>
                        </Androw>
                      </AndCol>
                    </Androw>
                  </>
                )}

                {primaryData && primaryData.length > 0 && (
                  <div className={`beneficiaries-content ${checkValue ? 'not-edit' : ''}`}>
                    <Androw justify="start">
                      <AntDivider style={{ margin: '12px 0' }}></AntDivider>
                    </Androw>
                    <Androw justify="start">
                      <AndCol
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <div className="tagging">
                          <span className="font-size17 font-setting500 grey-font">
                            {t('life.policies.Primarybeneficiaries')}
                          </span>
                        </div>
                        {checkValue && (
                          <div
                            style={{
                              background: '#E9573D',
                              borderRadius: '20px',
                              padding: '4px 8px',
                              fontSize: '15px',
                              fontFamily: 'Roboto700',
                              color: '#FFF',
                            }}
                          >
                            {t('life.beneficiaries.repending')}
                          </div>
                        )}
                      </AndCol>
                    </Androw>
                    <DividerLine></DividerLine>
                    <Androw justify="start">
                      <AndCol style={{ width: '100%' }}>
                        <Androw justify="start">
                          <Col lg={19} md={19} sm={15} xs={15}>
                            <div className="tagging">
                              <span className="font-size17 font-setting500"> {t('life.beneficiaries.name')}</span>
                              <span className="font-size17 grey-font">{t('life.policies.relationship')}</span>
                            </div>
                          </Col>
                          <Col span={1}>
                            <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
                          </Col>
                          <Col lg={4} md={4} sm={7} xs={7}>
                            <div
                              className="tagging"
                              style={{
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '100%',
                                marginLeft: '0',
                                padding: isEnglish ? '0' : '0 30px',
                              }}
                            >
                              <span className="font-size17 font-setting500 grey-font" style={{ textAlign: 'center' }}>
                                {t('life.policies.ShareAllocation')}
                              </span>
                            </div>
                          </Col>
                        </Androw>
                      </AndCol>
                    </Androw>
                    <DividerLine></DividerLine>
                    {primaryData.map((beneficiary, index) => {
                      return (
                        <Fragment key={index}>
                          <Androw justify="start">
                            <AndCol style={{ width: '100%', marginBottom: '16px' }}>
                              <Androw justify="start">
                                <Col
                                  lg={19}
                                  md={19}
                                  sm={15}
                                  xs={15}
                                  style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}
                                >
                                  <div className="tagging">
                                    <div
                                      style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}
                                    >
                                      {beneficiary.beneficiaryAction == 'add' && <img src={Added} alt="" />}
                                      {beneficiary.beneficiaryAction == 'removed' && <img src={Removed} alt="" />}
                                      <div
                                        className={`tagging  ${
                                          beneficiary.beneficiaryAction == 'add' ||
                                          beneficiary.beneficiaryAction == 'removed'
                                            ? 'tagging-special mg-l'
                                            : ''
                                        }`}
                                        style={{ marginLeft: 0 }}
                                      >
                                        <span className="font-size17 font-setting500">
                                          {beneficiary.surname + ' ' + beneficiary.givenName}
                                        </span>
                                        <span className="font-size17 grey-font">
                                          {isEnglish ? beneficiary.relationshipDesc : beneficiary.relationshipDescTc}
                                        </span>
                                      </div>
                                    </div>
                                    {(beneficiary.beneficiaryAction == 'add' ||
                                      beneficiary.beneficiaryAction == 'updated') && (
                                      <div onClick={() => openMore(beneficiary)}>
                                        <span
                                          className="font-size17 font-setting500"
                                          style={{ color: '#C21B17', marginRight: '12px' }}
                                        >
                                          {t('life.beneficiaries.reviewChanges')}
                                        </span>
                                        {showMoreList.find((more) => beneficiary.id === more.id)?.show ? (
                                          <img src={RedUp} />
                                        ) : (
                                          <img src={RedDown} />
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </Col>
                                <Col span={1}>
                                  <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
                                </Col>
                                <Col lg={4} md={4} sm={7} xs={7}>
                                  <div
                                    className="tagging"
                                    style={{
                                      flexDirection: 'row',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      height: '100%',
                                      marginLeft: '0',
                                      position: 'relative',
                                    }}
                                  >
                                    <span className="font-size17" style={{ textAlign: 'center' }}>
                                      {beneficiary.share?.indexOf('%') != -1
                                        ? beneficiary.share
                                        : beneficiary.share == '0'
                                        ? '-'
                                        : beneficiary.share + '%'}
                                    </span>
                                  </div>
                                </Col>
                              </Androw>
                            </AndCol>
                          </Androw>
                          {(index != primaryData.length - 1 || beneficiary.beneficiaryAction == 'removed') && (
                            <DividerLine></DividerLine>
                          )}
                          {showMoreList.find((more) => beneficiary.id === more.id)?.show && (
                            <Androw>
                              <AntDivider style={{ margin: '0 0 12px 0' }}></AntDivider>
                              <AndCol>
                                <div className="tagging">
                                  <span className="font-size17 font-setting500 grey-font">
                                    {t('life.beneficiaries.updated')}
                                  </span>
                                </div>
                              </AndCol>
                              <AntDivider style={{ margin: '12px 20px' }}></AntDivider>
                              <Form layout={'vertical'} className="form" style={{ width: '100%', margin: '0 20px' }}>
                                {showObj.map((key) => {
                                  if (beneficiary[key]) {
                                    let value = key != 'share' ? beneficiary[key] : showShare(beneficiary[key]);
                                    let oldData: Partial<beneficiariesForm> = {};
                                    if (oldBeneficiariesList.some((old) => old.id == beneficiary.id)) {
                                      oldData = oldBeneficiariesList.find(
                                        (old) => old.id == beneficiary.id,
                                      ) as beneficiariesForm;
                                    }
                                    // 處理日期字段
                                    if (key === 'birthDate' && moment.isMoment(value)) {
                                      value = value.format('YYYY-MM-DD');
                                    }
                                    if (descObj.includes(key))
                                      if (key == 'relationship' && `${beneficiary[key]}` == 'O') {
                                        value =
                                          (i18n.language == 'en'
                                            ? `${beneficiary[(key + 'Desc') as keyof beneficiariesForm]}`
                                            : `${beneficiary[(key + 'DescTc') as keyof beneficiariesForm]}`) +
                                          '-' +
                                          beneficiary.specifyRelationship;
                                      } else if (key == 'taxResidence')
                                        value =
                                          i18n.language == 'en'
                                            ? `${beneficiary[(key + 'Desc') as keyof beneficiariesForm]}`.replace(
                                                /;/g,
                                                ' ; ',
                                              )
                                            : `${beneficiary[(key + 'DescTc') as keyof beneficiariesForm]}`.replace(
                                                /;/g,
                                                ' ; ',
                                              );
                                      else
                                        value =
                                          i18n.language == 'en'
                                            ? `${beneficiary[(key + 'Desc') as keyof beneficiariesForm]}`
                                            : `${beneficiary[(key + 'DescTc') as keyof beneficiariesForm]}`;
                                    return (
                                      <Col xs={24} md={24} key={key}>
                                        <BoldLabelFormItem
                                          label={
                                            <span
                                              style={{
                                                color: '#6f7072',
                                                fontWeight: 'normal',
                                                fontSize: '17px',
                                                fontFamily: 'Roboto500',
                                                margin: '0 12px',
                                              }}
                                            >
                                              {t(`life.beneficiaries.${key}`)}
                                            </span>
                                          }
                                          name={key}
                                        >
                                          <div
                                            style={{
                                              border: 'none',
                                              borderBottom: '1px solid #CCCCCC',
                                              // color: "white",
                                              backgroundColor: 'transparent',
                                              fontSize: '20px',
                                              fontFamily: 'Roboto400',
                                              marginBottom: '10px',
                                              padding: '4px 0',
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              margin: '0 12px',
                                            }}
                                          >
                                            <div
                                              style={{
                                                width:
                                                  beneficiary.beneficiaryAction == 'updated' &&
                                                  ((key == 'taxResidence' &&
                                                    JSON.stringify([...(oldData[key] || [])].sort()) !=
                                                      JSON.stringify([...(beneficiary[key] || [])].sort())) ||
                                                    (key != 'share' &&
                                                      key != 'taxResidence' &&
                                                      oldData?.[key] != beneficiary[key]) ||
                                                    (key == 'share' &&
                                                      Number(oldData?.[key]) != Number(beneficiary[key])))
                                                    ? '62.5%'
                                                    : '100%',
                                              }}
                                            >
                                              {/* {
                                                // showCardNoMask
                                                //   ? formatCardNumber4(value)
                                                //   :
                                                value
                                              } */}
                                              {key == 'idNo'
                                                ? !showMoreList.find((more) => beneficiary.id === more.id)?.showIdcard
                                                  ? value
                                                  : formatIdlast5(value as string)
                                                : value}
                                            </div>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                              }}
                                            >
                                              {key == 'idNo' &&
                                                (showMoreList.find((more) => beneficiary.id === more.id)?.showIdcard ? (
                                                  <img
                                                    src={Visibility}
                                                    style={{ marginRight: key == 'idNo' ? '10px' : '0' }}
                                                    onClick={() => openMask(beneficiary)}
                                                  />
                                                ) : (
                                                  <img
                                                    src={VisibilityOff}
                                                    style={{ marginRight: key == 'idNo' ? '10px' : '0' }}
                                                    onClick={() => openMask(beneficiary)}
                                                  />
                                                ))}

                                              {beneficiary.beneficiaryAction == 'updated' &&
                                                ((key == 'taxResidence' &&
                                                  JSON.stringify([...(oldData[key] || [])].sort()) !=
                                                    JSON.stringify([...(beneficiary[key] || [])].sort())) ||
                                                  (key != 'share' &&
                                                    key != 'taxResidence' &&
                                                    oldData?.[key] != beneficiary[key]) ||
                                                  (key == 'share' &&
                                                    Number(oldData?.[key]) != Number(beneficiary[key]))) && (
                                                  <div
                                                    style={{
                                                      background: '#E9573D',
                                                      borderRadius: '20px',
                                                      padding: '4px 8px',
                                                      fontSize: '15px',
                                                      fontFamily: 'Roboto700',
                                                      color: '#FFF',
                                                      height: '31.5px',
                                                      // minWidth: '91px',
                                                    }}
                                                  >
                                                    {t('life.beneficiaries.updatePending')}
                                                  </div>
                                                )}
                                            </div>
                                          </div>
                                        </BoldLabelFormItem>
                                      </Col>
                                    );
                                  }
                                })}
                              </Form>
                            </Androw>
                          )}
                        </Fragment>
                      );
                    })}
                  </div>
                )}
              </StyledBlock>
              {secondary && secondary.length > 0 && (
                <StyledBlock className="back-f" style={{ marginBottom: 0 }}>
                  <div
                    className={`beneficiaries-content ${checkValue ? 'not-edit' : ''}`}
                    style={{ marginTop: '24px' }}
                  >
                    <Androw justify="start" style={{ paddingTop: '26px' }}>
                      {/* <AntDivider style={{ margin: '12px 0' }}></AntDivider> */}
                      <AndCol
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <div className="tagging">
                          <span className="font-size17 font-setting500 grey-font">
                            {t('life.policies.SecondaryTitle')}
                          </span>
                        </div>
                        {checkValue && (
                          <div
                            style={{
                              background: '#E9573D',
                              borderRadius: '20px',
                              padding: '4px 8px',
                              fontSize: '15px',
                              fontFamily: 'Roboto700',
                              color: '#FFF',
                            }}
                          >
                            {t('life.beneficiaries.repending')}
                          </div>
                        )}
                      </AndCol>
                    </Androw>
                    <DividerLine></DividerLine>
                    <Androw justify="start">
                      <AndCol style={{ width: '100%' }}>
                        <Androw justify="start">
                          <Col lg={19} md={19} sm={15} xs={15}>
                            <div className="tagging">
                              <span className="font-size17 font-setting500">{t('life.beneficiaries.name')}</span>
                              <span className="font-size17 grey-font">{t('life.policies.relationship')}</span>
                            </div>
                          </Col>
                          <Col span={1}>
                            <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
                          </Col>
                          <Col lg={4} md={4} sm={7} xs={7}>
                            <div
                              className="tagging"
                              style={{
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '100%',
                                marginLeft: '0',
                                padding: isEnglish ? '0' : '0 30px',
                              }}
                            >
                              <span className="font-size17 font-setting500 grey-font" style={{ textAlign: 'center' }}>
                                {t('life.policies.ShareAllocation')}
                              </span>
                            </div>
                          </Col>
                        </Androw>
                      </AndCol>
                    </Androw>
                    <DividerLine></DividerLine>
                    {secondary?.map((beneficiary, index) => {
                      return (
                        <Fragment key={index}>
                          <Androw justify="start">
                            <AndCol style={{ width: '100%', marginBottom: '16px' }}>
                              <Androw justify="start">
                                <Col
                                  lg={19}
                                  md={19}
                                  sm={15}
                                  xs={15}
                                  style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}
                                >
                                  <div className="tagging">
                                    <div
                                      style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}
                                    >
                                      {beneficiary.beneficiaryAction == 'add' && <img src={Added} alt="" />}
                                      {beneficiary.beneficiaryAction == 'removed' && <img src={Removed} alt="" />}
                                      <div
                                        className={`tagging  ${
                                          beneficiary.beneficiaryAction == 'add' ||
                                          beneficiary.beneficiaryAction == 'removed'
                                            ? 'tagging-special mg-l'
                                            : ''
                                        }`}
                                        style={{ marginLeft: 0 }}
                                      >
                                        <span className="font-size17 font-setting500">
                                          {beneficiary.surname + ' ' + beneficiary.givenName}
                                        </span>
                                        <span className="font-size17 grey-font">
                                          {isEnglish ? beneficiary.relationshipDesc : beneficiary.relationshipDescTc}
                                        </span>
                                      </div>
                                    </div>
                                    {(beneficiary.beneficiaryAction == 'add' ||
                                      beneficiary.beneficiaryAction == 'updated') && (
                                      <div onClick={() => openMore(beneficiary)}>
                                        <span
                                          className="font-size17 font-setting500"
                                          style={{ color: '#C21B17', marginRight: '12px' }}
                                        >
                                          {t('life.beneficiaries.reviewChanges')}
                                        </span>
                                        {showMoreList.find((more) => beneficiary.id === more.id)?.show ? (
                                          <img src={RedUp} />
                                        ) : (
                                          <img src={RedDown} />
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </Col>
                                <Col span={1}>
                                  <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
                                </Col>
                                <Col lg={4} md={4} sm={7} xs={7}>
                                  <div
                                    className="tagging"
                                    style={{
                                      flexDirection: 'row',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      height: '100%',
                                      marginLeft: '0',
                                      position: 'relative',
                                    }}
                                  >
                                    <span className="font-size17" style={{ textAlign: 'center' }}>
                                      {beneficiary.share?.indexOf('%') != -1
                                        ? beneficiary.share
                                        : beneficiary.share == '0'
                                        ? '-'
                                        : beneficiary.share + '%'}
                                    </span>
                                  </div>
                                </Col>
                              </Androw>
                            </AndCol>
                          </Androw>
                          {(index != secondary.length - 1 || beneficiary.beneficiaryAction == 'removed') && (
                            <DividerLine></DividerLine>
                          )}
                          {showMoreList.find((more) => beneficiary.id === more.id)?.show && (
                            <Androw>
                              <AntDivider style={{ margin: '0 0 12px 0' }}></AntDivider>
                              <AndCol>
                                <div className="tagging">
                                  <span className="font-size17 font-setting500 grey-font">
                                    {t('life.beneficiaries.updated')}
                                  </span>
                                </div>
                              </AndCol>
                              <AntDivider style={{ margin: '12px 20px' }}></AntDivider>
                              <Form layout={'vertical'} className="form" style={{ width: '100%', margin: '0 20px' }}>
                                {showObj.map((key) => {
                                  if (beneficiary[key]) {
                                    let value = key != 'share' ? beneficiary[key] : showShare(beneficiary[key]);
                                    let oldData: Partial<beneficiariesForm> = {};
                                    if (oldBeneficiariesList.some((old) => old.id == beneficiary.id))
                                      oldData = oldBeneficiariesList.find(
                                        (old) => old.id == beneficiary.id,
                                      ) as beneficiariesForm;
                                    // 處理日期字段
                                    if (key === 'birthDate' && moment.isMoment(value)) {
                                      value = value.format('YYYY-MM-DD');
                                    }
                                    if (descObj.includes(key))
                                      if (key == 'relationship' && `${beneficiary[key]}` == 'O') {
                                        value =
                                          (i18n.language == 'en'
                                            ? `${beneficiary[(key + 'Desc') as keyof beneficiariesForm]}`
                                            : `${beneficiary[(key + 'DescTc') as keyof beneficiariesForm]}`) +
                                          '-' +
                                          beneficiary.specifyRelationship;
                                      } else if (key == 'taxResidence')
                                        value =
                                          i18n.language == 'en'
                                            ? `${beneficiary[(key + 'Desc') as keyof beneficiariesForm]}`.replace(
                                                /;/g,
                                                ' ; ',
                                              )
                                            : `${beneficiary[(key + 'DescTc') as keyof beneficiariesForm]}`.replace(
                                                /;/g,
                                                ' ; ',
                                              );
                                      else
                                        value =
                                          i18n.language == 'en'
                                            ? `${beneficiary[(key + 'Desc') as keyof beneficiariesForm]}`
                                            : `${beneficiary[(key + 'DescTc') as keyof beneficiariesForm]}`;
                                    return (
                                      <Col xs={24} md={24}>
                                        <BoldLabelFormItem
                                          label={
                                            <span
                                              style={{
                                                color: '#6f7072',
                                                fontWeight: 'normal',
                                                fontSize: '17px',
                                                fontFamily: 'Roboto500',
                                                margin: '0 12px',
                                              }}
                                            >
                                              {t(`life.beneficiaries.${key}`)}
                                            </span>
                                          }
                                          name={key}
                                        >
                                          <div
                                            style={{
                                              border: 'none',
                                              borderBottom: '1px solid #CCCCCC',
                                              // color: "white",
                                              backgroundColor: 'transparent',
                                              fontSize: '20px',
                                              fontFamily: 'Roboto400',
                                              marginBottom: '10px',
                                              padding: '4px 0',
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              margin: '0 12px',
                                            }}
                                          >
                                            <div
                                              style={{
                                                width:
                                                  beneficiary.beneficiaryAction == 'updated' &&
                                                  ((key == 'taxResidence' &&
                                                    JSON.stringify([...(oldData[key] || [])].sort()) !=
                                                      JSON.stringify([...(beneficiary[key] || [])].sort())) ||
                                                    (key != 'share' &&
                                                      key != 'taxResidence' &&
                                                      oldData?.[key] != beneficiary[key]) ||
                                                    (key == 'share' &&
                                                      Number(oldData?.[key]) != Number(beneficiary[key])))
                                                    ? '62.5%'
                                                    : '100%',
                                              }}
                                            >
                                              {key == 'idNo'
                                                ? !showMoreList.find((more) => beneficiary.id === more.id)?.showIdcard
                                                  ? value
                                                  : formatIdlast5(value as string)
                                                : value}
                                            </div>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                              }}
                                            >
                                              {key == 'idNo' &&
                                                (showMoreList.find((more) => beneficiary.id === more.id)?.showIdcard ? (
                                                  <img
                                                    src={Visibility}
                                                    style={{ marginRight: key == 'idNo' ? '10px' : '0' }}
                                                    onClick={() => openMask(beneficiary)}
                                                  />
                                                ) : (
                                                  <img
                                                    src={VisibilityOff}
                                                    style={{ marginRight: key == 'idNo' ? '10px' : '0' }}
                                                    onClick={() => openMask(beneficiary)}
                                                  />
                                                ))}
                                              {beneficiary.beneficiaryAction == 'updated' &&
                                                ((key == 'taxResidence' &&
                                                  JSON.stringify([...(oldData[key] || [])].sort()) !=
                                                    JSON.stringify([...(beneficiary[key] || [])].sort())) ||
                                                  (key != 'share' &&
                                                    key != 'taxResidence' &&
                                                    oldData?.[key] != beneficiary[key]) ||
                                                  (key == 'share' &&
                                                    Number(oldData?.[key]) != Number(beneficiary[key]))) && (
                                                  <div
                                                    style={{
                                                      background: '#E9573D',
                                                      borderRadius: '20px',
                                                      padding: '4px 8px',
                                                      fontSize: '15px',
                                                      fontFamily: 'Roboto700',
                                                      color: '#FFF',
                                                      height: '31.5px',
                                                      // minWidth: '91px',
                                                    }}
                                                  >
                                                    {t('life.beneficiaries.updatePending')}
                                                  </div>
                                                )}
                                            </div>
                                          </div>
                                        </BoldLabelFormItem>
                                      </Col>
                                    );
                                  }
                                })}
                              </Form>
                            </Androw>
                          )}
                        </Fragment>
                      );
                    })}
                  </div>
                </StyledBlock>
              )}
              {!checkValue &&
                state.some((item) => item.beneficiaryAction == 'add' || item.beneficiaryAction == 'removed') && (
                  <StyledBlock className="back-f">
                    <div
                      className={`beneficiaries-content ${checkValue ? 'not-edit' : ''}`}
                      style={{ marginTop: '24px' }}
                    >
                      <Androw justify="start" style={{ paddingTop: '26px' }}>
                        {/* <AntDivider style={{ margin: '12px 0' }}></AntDivider> */}
                        <AndCol>
                          <div className="tagging">
                            <span className="font-size17 font-setting500 grey-font">
                              {t('life.beneficiaries.totalNo')}
                            </span>
                          </div>
                        </AndCol>
                      </Androw>
                      <DividerLine></DividerLine>
                      <Androw justify="start">
                        <AndCol style={{ width: '100%' }}>
                          <Androw justify="start">
                            <Col lg={19} md={19} sm={15} xs={15}>
                              <div
                                className="tagging"
                                style={{
                                  display: 'flex',
                                  justifyContent: 'flex-start',
                                  alignItems: 'center',
                                  flexDirection: 'row',
                                }}
                              >
                                <img src={Added} alt="" style={{ marginRight: '8px' }} />
                                <span className="font-size17 font-setting500">{t('life.beneficiaries.addNo')}</span>
                              </div>
                            </Col>
                            <Col span={1}>
                              <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
                            </Col>
                            <Col lg={4} md={4} sm={7} xs={7}>
                              <div
                                className="tagging"
                                style={{
                                  flexDirection: 'row',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  height: '100%',
                                  marginLeft: '0',
                                  padding: isEnglish ? '0' : '0 30px',
                                }}
                              >
                                <span className="font-size17 font-setting500 grey-font" style={{ textAlign: 'center' }}>
                                  {addno}
                                </span>
                              </div>
                            </Col>
                          </Androw>
                        </AndCol>
                      </Androw>
                      <DividerLine></DividerLine>
                      <Androw justify="start">
                        <AndCol style={{ width: '100%' }}>
                          <Androw justify="start">
                            <Col lg={19} md={19} sm={15} xs={15}>
                              <div
                                className="tagging"
                                style={{
                                  display: 'flex',
                                  justifyContent: 'flex-start',
                                  alignItems: 'center',
                                  flexDirection: 'row',
                                }}
                              >
                                <img src={Removed} alt="" style={{ marginRight: '8px' }} />
                                <span className="font-size17 font-setting500">{t('life.beneficiaries.removeNo')}</span>
                              </div>
                            </Col>
                            <Col span={1}>
                              <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
                            </Col>
                            <Col lg={4} md={4} sm={7} xs={7}>
                              <div
                                className="tagging"
                                style={{
                                  flexDirection: 'row',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  height: '100%',
                                  marginLeft: '0',
                                  padding: isEnglish ? '0' : '0 30px',
                                }}
                              >
                                <span className="font-size17 font-setting500 grey-font" style={{ textAlign: 'center' }}>
                                  {removeno}
                                </span>
                              </div>
                            </Col>
                          </Androw>
                        </AndCol>
                      </Androw>
                      <DividerLine></DividerLine>
                    </div>
                  </StyledBlock>
                )}
              <StyledBlock className="back-f">
                {!checkValue && isShowPep && (
                  <>
                    <Androw justify="center" style={{ marginTop: '16px' }}>
                      <Col
                        style={{
                          width: '100%',
                          margin: '0 20px',
                        }}
                      >
                        <Collapse
                          accordion
                          className="CollapseTax"
                          expandIconPosition="end"
                          defaultActiveKey={'CollapseTax'}
                          onChange={() => {
                            setShowBB(!showBB);
                          }}
                        >
                          <Panel
                            header={t('life.MakeRequest.contact.termstittle')}
                            key="CollapseTax"
                            forceRender={true}
                            style={{ borderBottom: showBB && pep.isDeclaration == 'No' ? 0 : '1px solid #d9d9d9' }}
                          >
                            <div
                              style={{
                                fontSize: '15px',
                                fontFamily: 'Roboto400',
                                paddingTop: '15px',
                                color: '#6F7072',
                                paddingBottom: '15px',
                                borderBottom: '1px solid #CCCCCC',
                              }}
                            >
                              <div dangerouslySetInnerHTML={{ __html: t('life.beneficiaries.PEP') }}></div>

                              <div className="font-size20 font-setting400 black-font">
                                {pep.isDeclaration == 'No' ? t('common.no') : t('common.yes')}
                              </div>
                            </div>
                            {pep.isDeclaration == 'Yes' && (
                              <>
                                <div
                                  style={{
                                    fontSize: '15px',
                                    fontFamily: 'Roboto400',
                                    paddingTop: '15px',
                                    color: '#6F7072',
                                    paddingBottom: '15px',
                                    // borderBottom: '1px solid #CCCCCC',
                                  }}
                                >
                                  <div>{t('life.beneficiaries.pepName')}</div>
                                  <div className="font-size20 font-setting400 black-font">{pep.pepName}</div>
                                </div>
                                <div
                                  style={{
                                    fontSize: '15px',
                                    fontFamily: 'Roboto400',
                                    paddingTop: '15px',
                                    color: '#6F7072',
                                    paddingBottom: '15px',
                                    // borderBottom: '1px solid #CCCCCC',
                                  }}
                                >
                                  <div>{t('life.beneficiaries.pepPosition')}</div>
                                  <div className="font-size20 font-setting400 black-font">{pep.pepPosition}</div>
                                </div>
                                <div
                                  style={{
                                    fontSize: '15px',
                                    fontFamily: 'Roboto400',
                                    paddingTop: '15px',
                                    color: '#6F7072',
                                    paddingBottom: '15px',
                                    // borderBottom: '1px solid #CCCCCC',
                                  }}
                                >
                                  <div>{t('life.beneficiaries.pepRelevant')}</div>
                                  <div className="font-size20 font-setting400 black-font">{pep.relevantPartyName}</div>
                                </div>
                                <div
                                  style={{
                                    fontSize: '15px',
                                    fontFamily: 'Roboto400',
                                    paddingTop: '15px',
                                    color: '#6F7072',
                                    paddingBottom: '15px',
                                    // borderBottom: '1px solid #CCCCCC',
                                  }}
                                >
                                  <div>{t('life.beneficiaries.pepRelationship')}</div>
                                  <div className="font-size20 font-setting400 black-font">{pep.pepRelationship}</div>
                                </div>
                              </>
                            )}
                          </Panel>
                        </Collapse>
                      </Col>
                    </Androw>
                    {(pep.isDeclaration == 'Yes' || highRiskC || highRiskP) && (
                      <Androw justify="center">
                        <Col>
                          <Form
                            layout={'vertical'}
                            style={{ width: '100%', margin: '0 16px' }}
                            requiredMark={false}
                            form={form}
                            className="form upload-form"
                          >
                            <DocumentsCard setInvalid={setDocumentInvalid} />
                          </Form>
                        </Col>
                      </Androw>
                    )}
                  </>
                )}

                <Androw
                  className="ChageBeneficialPage"
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    paddingLeft: 20,
                    paddingRight: 20,
                    paddingTop: 16,
                  }}
                >
                  <Button
                    // loading={enquirySubmissionIsLoading || isLoading}
                    disabled={documentInvalid}
                    onClick={confirmList}
                    type="primary"
                    className="submit"
                  >
                    {t('life.beneficiaries.submitafter.confirm')}
                  </Button>
                  <Button
                    // loading={enquirySubmissionIsLoading || isLoading}
                    onClick={() => {
                      navigate('/LIBenefiaries', {
                        state: {
                          editflag: true,
                          policyNo: policyNC,
                        },
                      });
                    }}
                    className="cancel"
                  >
                    {t('life.beneficiaries.submitafter.back')}
                  </Button>
                </Androw>
              </StyledBlock>
            </>
          )}
        </StyledBlock>
      </div>
    </ViewBeneficiariesContainer>
  );
}
